import type React from 'react';
import Image from 'next/image';
import { Card, CardContent } from '@/components/ui/card';
import { images } from '@/core';

interface IVerificationShellProps {
  children: React.ReactNode;
}

/**
 * Marco visual compartido por las dos pantallas públicas de verificación:
 * el buscador por ID (`/documents`) y el detalle (`/documents/[id]`).
 */
export function VerificationShell({ children }: IVerificationShellProps) {
  return (
    <div className="site-shell min-h-screen">
      <header className="site-header">
        <div className="mx-auto flex h-20 max-w-5xl items-center px-4 sm:px-6 lg:px-8">
          <Image src={images.logoText} alt="Tu Firma Digital" width={112} height={36} priority />
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl px-4 py-10 sm:px-6 lg:px-8 lg:py-12">{children}</main>
    </div>
  );
}

export function VerificationStateCard({ children }: IVerificationShellProps) {
  return (
    <Card className="overflow-hidden">
      <CardContent className="p-6 sm:p-8">{children}</CardContent>
    </Card>
  );
}
